/* Touch/pen input for the existing jQuery UI price filters. Mouse and keys stay native. */
(() => {
  const $ = window.jQuery;
  if (!$?.fn.slider || !window.PointerEvent) return;
  let drag = null;

  function mouse(type, event, target) {
    $(target).trigger($.Event(type, {
      which: 1,
      button: 0,
      buttons: type === 'mouseup' ? 0 : 1,
      pageX: event.pageX,
      pageY: event.pageY,
      clientX: event.clientX,
      clientY: event.clientY,
    }));
  }

  function finish(event, canceled = false) {
    if (!drag || (event.pointerId != null && event.pointerId !== drag.id)) return;
    const current = drag;
    drag = null;
    const widget = $(current.slider);
    const exists = Boolean(widget.slider('instance'));
    const stop = exists ? widget.slider('option', 'stop') : null;

    // Canceling a gesture must release jQuery UI's mouse state without submitting a filter.
    if (canceled && exists) widget.slider('option', 'stop', null);
    mouse('mouseup', current.last, document);
    if (canceled && exists) {
      widget.slider('option', 'stop', stop);
      widget.slider('values', current.values);
      const slide = widget.slider('option', 'slide');
      if (typeof slide === 'function' && current.slider.isConnected) {
        slide.call(current.slider, event, { values: current.values });
      }
    }
    if (current.slider.hasPointerCapture?.(current.id)) {
      current.slider.releasePointerCapture(current.id);
    }
  }

  // Delegation also covers filters rendered later by Meilisearch or the Shopify fallback.
  document.addEventListener('pointerdown', (event) => {
    if (drag || !['touch', 'pen'].includes(event.pointerType) ||
        event.isPrimary === false || event.button !== 0) return;
    const slider = event.target.closest?.('.collection-filter-price.ui-slider');
    if (!slider) return;
    const widget = $(slider);
    if (!widget.slider('instance') || widget.slider('option', 'disabled')) return;

    event.preventDefault(); // Suppress the browser's compatibility mouse events.
    drag = { id: event.pointerId, slider, values: widget.slider('values'), last: event };
    mouse('mousedown', event, event.target);
    // Retain the drag when a finger moves beyond the small visible handle/track.
    slider.setPointerCapture?.(event.pointerId);
  }, { passive: false });

  document.addEventListener('pointermove', (event) => {
    if (!drag || event.pointerId !== drag.id) return;
    if (!drag.slider.isConnected) {
      finish(event, true);
      return;
    }
    event.preventDefault();
    drag.last = event;
    mouse('mousemove', event, document);
  }, { passive: false });

  document.addEventListener('pointerup', (event) => finish(event));
  document.addEventListener('pointercancel', (event) => finish(event, true));
  document.addEventListener('lostpointercapture', (event) => finish(event, true));
  window.addEventListener('blur', (event) => finish(event, true));
})();
